import { z } from "zod";

export enum SupportedLanguageEnum {
  FR = "FR",
  EN = "EN",
}

export const UserInfoSchema = z.object({
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  creationDate: z.coerce.date(),
  validUntil: z.coerce.date(),
  language: z.nativeEnum(SupportedLanguageEnum),
  acceptedCgu: z.boolean(),
});

export type UserInfo = z.infer<typeof UserInfoSchema>;

export type RequestUpdateUser = {
  firstName: string;
  lastName: string;
  language: SupportedLanguageEnum;
};

export type RequestAcceptGcu = {
  cguVersion: string;
};
